import { Feature } from '@type/features'
import { JSX } from 'react'
import { UIFeatures } from '@models/Account'

export enum LinkGroupType {
  payable = 'payable',
  receivable = 'receivable',
}

export type LinkGroupOption = {
  label: string
  value: string
  feature?: Feature
  uiFeatureKey?: keyof UIFeatures
}

export type LinkGroupData = {
  getOptions(isAdmin: boolean, uiFeatures?: UIFeatures): LinkGroupOption[]
  isActive(path: string): boolean
  type: LinkGroupType
  feature?: Feature
}

export type SingleLinkObject = {
  to: string
  label: string | JSX.Element
  isActive: (path: string) => boolean
  feature?: Feature
  uiFeatureKey?: keyof UIFeatures
}
